module.exports = __webpack_public_path__ + "static/media/icon_delete.186b5d2b.svg";